import React, { useState, useEffect } from 'react'; // ← poprawione
import Logo from './assets/logo.png';
import BackgroundImage from './assets/background_1.png';
import MultipleScreenshotsLogo from './assets/MultipleScreenshots.png';
import XpathHelperLogo from './assets/xpathhelper.png';
import SitemapCheckerLogo from './assets/sitemapchecker.png';
import PricingSection from './PricingSection';
import Header from './Header';

const MainPage = () => {
    const [activeSection, setActiveSection] = useState('about');

    const scrollToSection = (sectionId) => {
        setActiveSection(sectionId);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // ⛳️ MUSI być wewnątrz komponentu:
    useEffect(() => {
        const section = localStorage.getItem('scrollToSection');
        if (section) {
            scrollToSection(section);
            localStorage.removeItem('scrollToSection');
        }
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
            <nav
                style={{
                    backgroundColor: 'white',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    position: 'sticky',
                    top: 0,
                    zIndex: 50,
                }}
            >
                <Header scrollToSection={scrollToSection} activeSection={activeSection} />
            </nav>



            {/* Hero Section */}
            <section className="relative py-20 px-4 bg-white overflow-hidden">
            <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between relative z-10">
                
                {/* Text Content */}
                <div className="w-full md:w-1/2 text-center md:text-left">
                <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                    Welcome to <span className="text-[rgb(0,131,234)]">Wentago</span>
                </h1>
                <p className="text-xl text-gray-600 mb-8 max-w-md mx-auto md:mx-0">
                    Automate the boring. Focus on what matters.
                </p>
                <button
                    onClick={() => scrollToSection('about')}
                    className="bg-[rgb(0,131,234)] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[rgb(0,100,180)] transform hover:scale-105 transition-all duration-200 shadow-lg"
                >
                    Learn more about us
                </button>
                </div>

                {/* Background Image */}
                <div className="w-full md:w-1/2 flex justify-center md:justify-end relative">
                <img
                    src={BackgroundImage}
                    alt="Hero Visual"
                    className="max-w-sm md:max-w-md lg:max-w-lg opacity-80"
                />
                </div>

            </div>
            </section>

            {/* About Us Section */}
            <section id="about" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">About Us</h2>
                <div className="w-24 h-1 bg-[rgb(0,131,234)] mx-auto"></div>
                </div>

                <div className="grid md:grid-cols-2 gap-12 items-start">
                <div>
                    <p className="text-gray-700 text-lg leading-relaxed mb-6">
                    Wentago is a small, independent studio creating lightweight tools for automating repetitive web-based work. 
                    We specialize in building focused solutions that simplify digital workflows and eliminate friction from your day.
                    </p>

                    <p className="text-gray-700 text-lg leading-relaxed mb-6">
                    We focus on building practical, lightweight automations that reduce repetitive web tasks to a single click — or eliminate them entirely. Whether it’s speeding up routine checks, removing friction in testing, or simplifying data collection, we aim to give you back your time.
                    </p>

                </div>

                <div>
                    <p className="text-gray-700 text-lg leading-relaxed mb-6">
                    Our tools are built for those who keep the internet moving:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 text-lg space-y-2 mb-6">
                    <li>Developers</li>
                    <li>Web designers & UI/UX teams</li>
                    <li>QA & testing engineers</li>
                    <li>Data analysts & scraping specialists</li>
                    <li>SEO and e-commerce professionals</li>
                    <li>Automation enthusiasts & tech teams</li>
                    </ul>
                    <p className="text-gray-700 text-lg leading-relaxed">
                    If your daily work involves the browser — we’re building tools for you.
                    </p>
                </div>
                </div>

                <div className="text-center mt-12">
                <a
                    href="mailto:kontakt@wentago.pl"
                    className="inline-block bg-[rgb(0,131,234)] hover:bg-[rgb(0,100,180)] text-white text-lg font-semibold px-6 py-3 rounded-lg shadow-md transition-all duration-200"
                >
                    Contact us
                </a>
                </div>
            </div>
            </section>

            {/* Products Section */}
            <section id="products" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Products</h2>
                <div className="w-24 h-1 bg-[rgb(0,131,234)] mx-auto mb-6"></div>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                    Small tools. Big impact. Built for real-world workflows and browser-based tasks.
                </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                {/* Multiple Screenshots */}
                <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
                    <div className="flex justify-center mb-6">
                    <a
                        href="https://chromewebstore.google.com/detail/multiple-screenshots/gbgeckhegkbgdlfpcgjdhdckdfcimmbc"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                        src={MultipleScreenshotsLogo}
                        alt="Multiple Screenshots logo"
                        className="w-16 h-16 object-contain transition-transform duration-300 hover:scale-110"
                        />
                    </a>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">Multiple Screenshots</h3>
                    <p className="text-gray-600 mb-6 text-center">
                    A modern screenshot companion built for power users. Capture, scroll, highlight and merge — all in one.
                    </p>
                    <ul className="text-gray-600 space-y-2 text-sm">
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Full-page and element screenshots</li>
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Highlight with scroll & auto-capture</li>
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Merge into a single file</li>
                    </ul>
                </div>

                {/* XPath Helper 2.0 */}
                <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
                    <div className="flex justify-center mb-6">
                    <a
                        href="https://chromewebstore.google.com/detail/xpath-helper-20/nlfdopnkeodpiondihlgnhgpjieoopbj?hl=pl&utm_source=ext_sidebar"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                        src={XpathHelperLogo}
                        alt="XPath Helper 2.0 logo"
                        className="w-16 h-16 object-contain transition-transform duration-300 hover:scale-110"
                        />
                    </a>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">XPath Helper 2.0</h3>
                    <p className="text-gray-600 mb-6 text-center">
                    A tribute to the original legend. Free, open, and just as powerful — inspect, test and refine your XPath queries in real-time.
                    </p>
                    <ul className="text-gray-600 space-y-2 text-sm">
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Live XPath evaluation</li>
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Built-in DOM navigator & editor</li>
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> 100% free & privacy-friendly</li>
                    </ul>
                </div>

                {/* Sitemap Checker */}
                <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
                    <div className="flex justify-center mb-6">
                    <a
                        href="https://chromewebstore.google.com/detail/sitemap-checker/jajeocnjkklcikjjghgleehlckphifpd"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                        src={SitemapCheckerLogo}
                        alt="Sitemap Checker logo"
                        className="w-16 h-16 object-contain transition-transform duration-300 hover:scale-110"
                        />
                    </a>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">Sitemap Checker</h3>
                    <p className="text-gray-600 mb-6 text-center">
                    Extract and analyze any sitemap — even `.gz` files — and convert them into clean, actionable CSV files.
                    </p>
                    <ul className="text-gray-600 space-y-2 text-sm">
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Parses standard & compressed sitemaps</li>
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Export to CSV or use filtering</li>
                    <li className="flex items-start"><span className="text-green-500 mr-2 mt-1">✔</span> Fast and completely free</li>
                    </ul>
                </div>
                </div>
            </div>
            </section>

            {/* Products Section */}
            <section id="products" className="py-20 bg-gray-50">
            ...
            </section>

            {/* Pricing Section */}
            <PricingSection />



            <footer className="bg-gray-900 text-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8">
                {/* Logo and Description */}
                <div className="col-span-2">
                    <h3 className="text-2xl font-bold mb-4">Wentago</h3>
                    <p className="text-gray-400 mb-4">
                    We build smart web tools that streamline your daily browser actions.
                    </p>
                    <div className="flex space-x-4">
                    <img
                        src={Logo}
                        alt="Wentago Logo"
                        className="w-12 h-12 object-contain transition-transform duration-300 hover:scale-110"
                    />
                    </div>
                </div>

                {/* Contact */}
                <div>
                    <h4 className="text-lg font-semibold mb-4">Contact</h4>
                    <ul className="text-gray-400 space-y-2">
                    <li>kontakt@wentago.pl</li>
                    <li>Wentago</li>
                    <li>15-773 Białystok</li>
                    <li>Poland</li>
                    </ul>
                </div>

                {/* Policies and Navigation Links */}
                <div>
                    <h4 className="text-lg font-semibold mb-4">Policies & Links</h4>
                    <ul className="text-gray-400 space-y-2">
                    <li><a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a></li>
                    <li><a href="/return-policy" className="hover:text-white transition-colors">Return Policy</a></li>
                    <li><a href="/terms" className="hover:text-white transition-colors">Terms of Service</a></li>
                    <li><button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors">About Us</button></li>
                    <li><button onClick={() => scrollToSection('products')} className="hover:text-white transition-colors">Products</button></li>
                    <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white transition-colors">Pricing</button></li>
                    </ul>
                </div>
                </div>

                <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
                <p>&copy; 2025 Wentago. All rights reserved.</p>
                </div>
            </div>
            </footer>

        </div>
    );
};

export default MainPage;